/**
 * Every Container row this session has seen, by id and by number.
 *
 * The Dashboard's row list is not a fleet. It is the answer to the CURRENT
 * query - replaced whole on every search, chip and filter - and it arrives a page
 * at a time. Three lookups in app.js used to read a `dashboardRows` array
 * captured once at page load, so what they could find depended on what happened
 * to be on screen when the Dashboard opened, and on nothing else.
 *
 * That is what emptied the Empty Return leg's destination (Alan, 2026-08-21:
 * "第一个空柜的return to 根本不显示。但是表格里面是有的"). The release panel finds
 * the paired empty BY NUMBER so it can read that empty's own Empty To - the
 * empty's route lives on the empty and is deliberately not copied onto the load
 * (his rule, 2026-08-16: "重柜是单独的不要把空柜的 empty from 和 empty to 同步到重柜
 * 表格上"). When the lookup missed, the leg fell back to the load's own fields,
 * which have no Empty To at all, and drew "→ —" while the table two panes over
 * was showing PCT from the very row the lookup could not reach.
 *
 * Its own module so the fix is testable: the failure was never in the panel that
 * reads the row, it was in the thing that finds it.
 */

const byId = new Map();
const byNumber = new Map();

/**
 * Rows are replaced rather than merged, so the newest view of a Container wins.
 * Nothing is ever removed: a Container that has left the current query has not
 * stopped existing, and that is the whole point.
 */
export function rememberContainerRows(rows) {
  for (const row of Array.isArray(rows) ? rows : []) {
    if (!row || typeof row !== 'object') continue;
    if (typeof row.id === 'string' && row.id) byId.set(row.id, row);
    const number = String(row.container_no ?? '').trim().toUpperCase();
    if (number) byNumber.set(number, row);
  }
}

export function containerRowById(id) {
  const key = String(id ?? '');
  return key ? byId.get(key) ?? null : null;
}

export function containerRowByNumber(number) {
  const key = String(number ?? '').trim().toUpperCase();
  return key ? byNumber.get(key) ?? null : null;
}

/** Signing out is the one thing that should forget. */
export function forgetContainerRows() {
  byId.clear();
  byNumber.clear();
}
